import React, { useEffect,useState } from "react";
import "./Registration.css";



  const applicationItems = [
    {
      number: "01",
      title: "Application review",
      description: "Provider & manager applications",
      status: "complete",
    },
    {
      number: "02",
      title: "Statement of Purpose",
      description: "Clear, accurate and compliant",
      status: "complete",
    },
    {
      number: "03",
      title: "Policies & evidence",
      description: "Built around your service",
      status: "complete",
    },
    {
      number: "04",
      title: "Interview preparation",
      description: "Mock questions and coaching",
      status: "progress",
    },
  ];

    const menuItems = [
      {
        title: "Specialist",
        paragraph: "Care-sector knowledge",
      },
      {
        title: "Practical",
        paragraph: "Hands-on application help",
      },
      {
        title: "Personal",
        paragraph: "A dedicated adviser",
      },
      {
        title: "Prepared",
        paragraph: "Interview coaching included",
      },
    ];

    const registrationServices = [
  {
    number: "01",
    title: "Registration strategy",
    description:
      "We assess your service model, regulated activities, location and leadership structure before you apply.",
  },
  {
    number: "02",
    title: "Application support",
    description:
      "Guidance with provider, partner and registered manager forms, including accurate and consistent responses.",
  },
  {
    number: "03",
    title: "Statement of Purpose",
    description:
      "A professionally prepared Statement of Purpose aligned with your service, client group and regulated activities.",
  },
  {
    number: "04",
    title: "Policies & evidence",
    description:
      "A tailored evidence checklist and support with the core policies, procedures and governance documents CQC expects.",
  },
  {
    number: "05",
    title: "Registered manager coaching",
    description:
      "Preparation for the fit-person interview, including mock questions, feedback and improvement actions.",
  },
  {
    number: "06",
    title: "Submission & follow-up",
    description:
      "Final quality checks, submission guidance and support responding to CQC requests during assessment.",
  },
];

const careJourneySteps = [
  {
    id: 1,
    heading: "Discovery & readiness review",
    text: "We understand your service and identify what is needed before submission.",
  },
  {
    id: 2,
    heading: "Build your application pack",
    text: "We prepare and review the forms, Statement of Purpose and supporting evidence.",
  },
  {
    id: 3,
    heading: "Prepare for assessment",
    text: "We coach the nominated individual or registered manager for the CQC interview.",
  },
  {
    id: 4,
    heading: "Submit & support",
    text: "You submit with confidence, with us available for questions and follow-up.",
  },
];


const supportCards = [
  {
    icon: "⌂",
    title: "Care homes",
    description: "Residential, nursing and specialist services",
  },
  {
    icon: "♡",
    title: "Homecare agencies",
    description: "Domiciliary care and supported living",
  },
  {
    icon: "+",
    title: "New providers",
    description: "First-time operators entering the sector",
  },
  {
    icon: "↻",
    title: "Existing providers",
    description: "New locations, activities and manager changes",
  },
];

const pricingPlans = [
  {
    type: "ESSENTIAL",
    title: "Registration Support",
    pricePrefix: "From",
    price: "£2,500",
    suffix: "+ VAT",
    description:
      "Structured expert support for providers who will complete parts of the application themselves.",
    features: [
      "Readiness consultation",
      "Application form review",
      "Statement of Purpose",
      "Evidence checklist",
      "Interview preparation",
    ],
    button: "Discuss this package",
    featured: false,
  },
  {
    type: "FULL SUPPORT",
    title: "Managed Registration",
    pricePrefix: "Tailored",
    price: "Proposal",
    suffix: "",
    description:
      "Hands-on, end-to-end support for complex applications or teams that want a managed process.",
    features: [
      "Everything in Essential",
      "Application drafting support",
      "Tailored policies and governance",
      "Multiple coaching sessions",
      "Ongoing CQC response support",
    ],
    button: "Get a tailored proposal",
    featured: true,
    badge: "MOST COMPREHENSIVE",
  },
];

const faqData = [
  {
    question: "When should I start preparing my CQC application?",
    answer:
      "Start before you are ready to operate. Your service model, premises, leadership, policies and evidence need to align. An early readiness review can identify gaps before they delay submission.",
  },
  {
    question: "Can you help with a registered manager application?",
    answer:
      "Yes. We can support you with the registered manager application, preparation, documentation and the overall CQC process.",
  },
  {
    question: "Do you support new locations and regulated activities?",
    answer:
      "Yes. We support care providers with new locations, regulated activities and the relevant CQC registration requirements.",
  },
  {
    question: "How long does CQC registration take?",
    answer:
      "The timeframe can vary depending on the application, service type, documentation and CQC assessment process.",
  },
  {
    question: "Is registration approval guaranteed?",
    answer:
      "No. CQC registration cannot be guaranteed. However, thorough preparation can help ensure your application meets the required standards.",
  },
];

const Registration  = () => {

   const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

 const [menuOpen, setMenuOpen] = useState(false);

 const [formData, setFormData] = useState({
    fullName: "",
    organisation: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

   const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);

    // Add your API call here
  };


  return (
    <>
    <section>
      <main className="cqc-hero">
        <div className="cqc-container">
          {/* Left Content */}
          <section className="cqc-content">

            <div className="cqc-label">
              <span></span>
              CQC REGISTRATION SUPPORT
            </div>

            <h1>
              Get CQC registered with
              <br />
              <span>clarity and confidence.</span>
            </h1>

            <p className="cqc-description">
              Expert, end-to-end support for new care providers, registered
              managers and existing services making changes to their
              registration.
            </p>

            <div className="cqc-actions">

              <a
                href="#Contact"
                className="primary-button"
              >
                Book a free consultation
                <span>→</span>
              </a>

              <a
                href="#process"
                className="secondary-button"
              >
                See how it works
                <span>↓</span>
              </a>

            </div>

            <div className="cqc-divider"></div>

            <div className="cqc-features">

              <div>
                <span className="check">✓</span>
                Care-sector specialists
              </div>

              <div>
                <span className="check">✓</span>
                Personal support
              </div>

              <div>
                <span className="check">✓</span>
                Fixed-fee packages
              </div>

            </div>

          </section>

          {/* Right Card */}
          <section className="registration-card-wrapper">

            <div className="registration-card">

              {/* Card Header */}
              <div className="card-header">

                <div className="readiness-label">
                  <span></span>
                  REGISTRATION READINESS
                </div>

                <h2>
                  Your CQC application, organised.
                </h2>

                <div className="progress-line">
                  <span></span>
                </div>

              </div>

              {/* Application Items */}
              <div className="application-list">

                {applicationItems.map((item) => (
                  <div
                    className="application-item"
                    key={item.number}
                  >

                    <div className="item-number">
                      {item.number}
                    </div>

                    <div className="item-details">
                      <strong>{item.title}</strong>
                      <span>{item.description}</span>
                    </div>

                    {item.status === "complete" ? (
                      <div className="complete-icon">
                        ✓
                      </div>
                    ) : (
                      <div className="progress-status">
                        In progress
                      </div>
                    )}

                  </div>
                ))}

              </div>

              {/* Advisor */}
              <div className="advisor-card">

                <div className="advisor-icon">
                  WD
                </div>

                <div className="advisor-content">
                  <strong>
                    Dedicated adviser
                  </strong>

                  <span>
                    Support at every stage
                  </span>
                </div>

                <div className="advisor-dots">
                  •••
                </div>

              </div>

              {/* Floating Badge */}
              <div className="floating-badge">
                <strong>
                  End-to-end
                </strong>

                <span>
                  application support
                </span>
              </div>

            </div>

          </section>

        </div>

        {/* Scroll Down Mouse Animation */}
        <div className="scroll-indicator">
          <div className="mouse">
            <span className="wheel"></span>
          </div>
          <span className="scroll-text">Scroll Down</span>
        </div>
      </main>
    </section>
    <section className="care-provider-nav">
     <div className="care-provider-container">
        <nav className="care-provider-menu">
          {menuItems.map((item, index) => (
            <a href="#" className="care-provider-item" key={index}>
              <h4>{item.title}</h4>

              <p>{item.paragraph}</p>
            </a>
          ))}
        </nav>
      </div>
    </section>
     <header className="cqc-header">
        <div className="cqc-header-inner">
          <nav className={`cqc-nav ${menuOpen ? "mobile-open" : ""}`}>
            <a href="#what-we-do">What we do</a>
            <a href="#process">Our process</a>
            <a href="#packages">Packages</a>
            <a href="#faqs">FAQs</a>
          </nav>
        </div>
    </header>
     <section className="registration-support" id="what-we-do">
      <div className="registration-container">

        {/* Heading */}
        <div className="registration-header">
          <div className="registration-heading">
            <div className="registration-label">
              <span></span>
              COMPLETE REGISTRATION SUPPORT
            </div>

            <h2>
              Everything you need to submit a strong
              <br className="desktop-break" />
              application
            </h2>
          </div>

          <div className="registration-intro">
            <p>
              We turn a complex registration process into a clear, managed
              plan — helping you prepare the right evidence and avoid
              preventable delays.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="registration-grid">
          {registrationServices.map((service) => (
            <div className="registration-card" key={service.number}>
              <div className="card-number">
                {service.number}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <span className="card-arrow">↗</span>
            </div>
          ))}
        </div>
      </div>
    </section>
     <section className="care-journey" id="process">
      <div className="care-journey-inner">

        {/* Left Section */}
        <div className="care-journey-info">

          <div className="care-journey-label">
            <span className="care-journey-label-line"></span>
            A CLEAR ROUTE TO REGISTRATION
          </div>

          <h2 className="care-journey-title">
            From first conversation to
            <br />
            CQC decision
          </h2>

          <p className="care-journey-text">
            Your adviser coordinates each stage, keeps your documents
            consistent and makes sure you know what happens next.
          </p>

          <button className="care-journey-action">
            <span>Start your registration</span>
            <span className="care-journey-action-icon">→</span>
          </button>

        </div>

        {/* Right Section */}
        <div className="care-journey-list">

          {careJourneySteps.map((step, index) => (
            <div className="care-journey-row" key={step.id}>

              <div className="care-journey-index">
                {step.id}
              </div>

              <div className="care-journey-details">
                <h3 className="care-journey-heading">
                  {step.heading}
                </h3>

                <p className="care-journey-description">
                  {step.text}
                </p>
              </div>

              {index !== careJourneySteps.length - 1 && (
                <span className="care-journey-line"></span>
              )}

            </div>
          ))}

        </div>

      </div>
    </section>
      <section className="who-support-section">
      <div className="who-support-container">

        <div className="who-support-heading">
          <div className="support-label">
            <span className="support-line"></span>
            <span>WHO WE SUPPORT</span>
          </div>

          <h2>Advice shaped around your service</h2>
        </div>

        <div className="support-grid">
          {supportCards.map((card, index) => (
            <div className="support-card" key={index}>
              <div className="support-icon">
                {card.icon}
              </div>

              <h3>{card.title}</h3>

              <p>{card.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
    
     <section className="pricing-section"id="packages">
       <div className="pricing-header">
      <div className="pricing-header-content">
        <span className="pricing-label">STRAIGHTFORWARD PRICING</span>
        <h1>Choose the support that suits you</h1>
        <p>
          Every application is different. We confirm scope and fees after a
          free initial consultation.
        </p>      
      </div>
    </div>
      
      <div className="pricing-container">
        {pricingPlans.map((plan, index) => (
          <div
            className={`pricing-cards ${
              plan.featured ? "pricing-card-featured" : ""
            }`}
            key={index}
          >
            {plan.badge && (
              <span className="pricing-badge">{plan.badge}</span>
            )}

            <div className="pricing-type">{plan.type}</div>

            <h2>{plan.title}</h2>

            <div className="pricing-price">
              <span className="price-prefix">{plan.pricePrefix}</span>

              <span className="price">{plan.price}</span>

              {plan.suffix && (
                <span className="price-suffix">{plan.suffix}</span>
              )}
            </div>

            <p className="pricing-description">{plan.description}</p>

            <ul className="pricing-features">
              {plan.features.map((feature, featureIndex) => (
                <li key={featureIndex}>
                  <span className="check-icon">✓</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <button
              type="button"
              className={`pricing-button ${
                plan.featured ? "pricing-button-filled" : ""
              }`}
            >
              {plan.button}
            </button>
          </div>
        ))}
      </div>
    </section>
     <section className="faq-section" id="faqs">
      <div className="faq-container">

        {/* Left Content */}
        <div className="faq-intro">
          <div className="faq-label">
            <span className="faq-label-line"></span>
            FREQUENTLY ASKED QUESTIONS
          </div>

          <h2>What providers ask us</h2>

          <p>
            Still unsure where to start? Book a free call and we’ll explain
            which route applies to your service.
          </p>

          <a href="#contact" className="faq-link">
            Ask us a question <span>→</span>
          </a>
        </div>

        {/* FAQ Accordion */}
        <div className="faq-list">
          {faqData.map((faq, index) => {
            const isOpen = activeIndex === index;

            return (
              <div
                className={`faq-item ${isOpen ? "active" : ""}`}
                key={index}
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={isOpen}
                >
                  <span>{faq.question}</span>

                  <span className="faq-icon">
                    {isOpen ? "×" : "+"}
                  </span>
                </button>

                <div
                  className={`faq-answer ${
                    isOpen ? "faq-answer-open" : ""
                  }`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
      <section className="consult-section" Id="Contact">
      <div className="consultation-container">

        {/* LEFT CONTENT */}
        <div className="consultation-content">
          <div className="consultation-label">
            <span></span>
            LET’S GET YOU REGISTERED
          </div>

          <h2>
            Tell us about your care
            <br className="desktop-break" /> service
          </h2>

          <p>
            Book a free initial consultation. We’ll discuss your plans,
            explain the likely registration route and recommend the right
            level of support.
          </p>

          <div className="consultation-points">
            <div className="consultation-point">
              <span className="check-icon">✓</span>
              <span>No-obligation initial call</span>
            </div>

            <div className="consultation-point">
              <span className="check-icon">✓</span>
              <span>Clear scope and fixed fees</span>
            </div>

            <div className="consultation-point">
              <span className="check-icon">✓</span>
              <span>Specialist care-sector advice</span>
            </div>
          </div>
        </div>

        {/* FORM */}
          <form
            className="consult-form"
            onSubmit={handleSubmit}
          >
            <div className="form-grid">

              {/* Full Name */}
              <div className="form-group">
                <label htmlFor="fullName">Full name</label>
                <input
                  id="fullName"
                  type="text"
                  name="fullName"
                  placeholder="Your name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </div>

              {/* Organisation */}
              <div className="form-group">
                <label htmlFor="organisation">Organisation</label>
                <input
                  id="organisation"
                  type="text"
                  name="organisation"
                  placeholder="Company name"
                  value={formData.organisation}
                  onChange={handleChange}
                />
              </div>

              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="name@company.co.uk"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              {/* Phone */}
              <div className="form-group">
                <label htmlFor="phone">Phone number</label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder="Your number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

            </div>

            {/* Service */}
            <div className="form-group full-width">
              <label htmlFor="service">Service type</label>

              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select your service
                </option>
                <option value="cqc-registration">
                  CQC Registration
                </option>
                <option value="cqc-compliance">
                  CQC Compliance
                </option>
                <option value="care-home-sales">
                  Care Home Sales
                </option>
                <option value="accounting">
                  Accounting
                </option>
                <option value="operational-management">
                  Operational Management
                </option>
                <option value="other">
                  Other
                </option>
              </select>
            </div>

            {/* Message */}
            <div className="form-group full-width">
              <label htmlFor="message">How can we help?</label>

              <textarea
                id="message"
                name="message"
                placeholder="Tell us where you are in the registration process..."
                value={formData.message}
                onChange={handleChange}
                rows="4"
              ></textarea>
            </div>

            {/* Submit */}
             
            <button
              type="submit"
              className="consultation-submit">
              <a className="primary-pera" href='mailto:chaudhary10sh@gmail.com?subject=Total%20Care%20Rota%20Demo'>Request my free consultation<span>→</span></a>
            </button>

            <p className="form-disclaimer">
              By submitting this form, you agree that we may contact you
              about your enquiry.
            </p>
          </form>
       

      </div>
    </section>
    

    
     
    </>
  )
}

export default Registration 
